import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { feedbackActions } from '../../state/stores/feedback';
import { Error, Success } from './error';

import styles from './feedbackForm.module.scss';

import submitBtn from './assets/btn-submit-feedback.png';

export class FeedbackForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            name: this.props.user.player.name,
            email: this.props.user.player.email,
            comments: '',
            csrf_token: '',
            form_submitted: '1',
            success: false,
            isError: false,
            error: '',
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.submitFeedback = this.submitFeedback.bind(this);
    }

    componentDidMount() {
        this.getPlayerInfo();
        this.getCsrf();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user.player.name !== this.props.user.player.name) {
            this.getPlayerInfo();
        }
    }

    async getPlayerInfo() {
        this.setState({
            disabled: false,
            name: this.props.user.player.name,
            email: this.props.user.player.email,
            comments: '',
            form_submitted: '1',
        });
    }

    async getCsrf() {
        const { newToken } = await this.props.getCsrfToken();
        this.setState({
            csrf_token: newToken,
        });
    }

    handleNameChange(event) {
        this.setState({
            name: event.target.value,
        });
    }

    handleEmailChange(event) {
        this.setState({
            email: event.target.value,
        });
    }

    handleCommentChange(event) {
        this.setState({
            comments: event.target.value,
        });
    }

    async submitFeedback(event) {
        event.preventDefault();

        this.setState({
            disabled: true,
            success: false,
            isError: false,
            error: '',
        });

        if (!this.state.disabled) {
            const { success, isError, error } = await this.props.postFeedback(
                this.state
            );
            this.setState({
                success,
                isError,
                error,
            });
            document.getElementById('feedback-form').scrollIntoView(true);
        }

        if (!this.state.isError) {
            this.setState({comments: ''});
            setTimeout(() => {
                this.setState({disabled: false})
            }, 500);
        }

        if (this.state.isError) {
            setTimeout(() => {
                this.setState({disabled: false})
            }, 500);
        }

        // we tried submitting so get a new csrf
        this.getCsrf();
    }

    render() {
        const formUrl = '/monopoly/feedback.php';

        return (
            <div className={styles.help}>
                <div className={styles.direction}>
                    <p>
                        Please use this form to submit your questions or
                        comments pertaining to the MONOPOLY For Life Second Chance Promotion.
                        Just fill out the fields below and click the{' '}
                        ‘<strong>Submit</strong>’ button.
                    </p>
                </div>
                <div id="feedback-form" className={styles.feedbackForm}>
                    <Error
                        isError={this.state.isError}
                        errors={this.state.error}
                    />
                    <Success success={this.state.success} />
                    <form
                        name="feedback_form"
                        id="feedback_form"
                        action={formUrl}
                        disabled={this.state.disabled}
                        method="post"
                        encType="application/x-www-form-urlencoded"
                        onSubmit={this.submitFeedback}
                    >
                        <div className={styles.feedbackField}>
                            <label htmlFor="email">Email:</label>
                            <input
                                type="text"
                                id="email"
                                name="email"
                                value={this.state.email}
                                onChange={this.handleEmailChange}
                                size="32"
                                maxLength="60"
                                placeholder="Enter E-mail"
                                className="form-control"
                            />
                        </div>
                        <div className={styles.feedbackField}>
                            <label htmlFor="name">Full Name:</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={this.state.name}
                                size="32"
                                maxLength="120"
                                onChange={this.handleNameChange}
                                placeholder="Enter Name"
                                className="form-control"
                            />
                        </div>
                        <div className={styles.feedbackField}>
                            <label htmlFor="comments">Comments:</label>
                            <textarea
                                id="comments"
                                name="comments"
                                value={this.state.comments}
                                onChange={this.handleCommentChange}
                                rows="10"
                                cols="50"
                                wrap="soft"
                                className="form-control"
                            />
                        </div>
                        <button
                            id="entry-submit"
                            className={styles.btnSubmit}
                            name="submit"
                            type="submit"
                            disabled={this.state.disabled}
                        >
                            <img
                                src={submitBtn}
                                alt="Submit"
                                title="Submit"
                            />
                        </button>
                    </form>
                </div>
            </div>
        );
    }
}

FeedbackForm.propTypes = {
    user: PropTypes.object.isRequired,
    postFeedback: PropTypes.func.isRequired,
    getCsrfToken: PropTypes.func.isRequired,
};

export default connect(
    ({ user }) => ({
        user,
    }),
    dispatch => ({
        postFeedback: feedbackActions(dispatch).postFeedback,
        getCsrfToken: feedbackActions(dispatch).getCsrfToken,
    })
)(FeedbackForm);
